<template>
	<div>
		<router-view></router-view>
	</div>
</template>
<script>
export default {
	name: 'page-description-job',
};
</script>


// WEBPACK FOOTER //
// src/modules/job-profile/pages/page-description-job.vue